import { api } from '@/lib/api'
import type { APIResponse } from '@/types/api'
import type { UserOptions, UserOptionsMode } from '@/types/user-options'

export interface SetUserOptionsData {
	userID: string
	companyID: string
	projectIDs: string[]
	hourTypeIDs: string[]
	mode: UserOptionsMode
}

export class UserOptionsService {
	static async getUserOptions(userID: string, companyID: string): Promise<UserOptions> {
		const response = await api.get<APIResponse<UserOptions>>('/user-options', {
			params: { userID, companyID },
		})
		const apiResponse = response.data

		if (!apiResponse.success || !apiResponse.data) {
			throw new Error(apiResponse.message || 'Error al obtener opciones del usuario')
		}

		return apiResponse.data
	}

	static async setUserOptions(data: SetUserOptionsData): Promise<UserOptions> {
		const response = await api.post<APIResponse<UserOptions>>('/user-options', data)
		const apiResponse = response.data

		if (!apiResponse.success || !apiResponse.data) {
			throw new Error(apiResponse.message || 'Error al guardar opciones del usuario')
		}

		return apiResponse.data
	}
}
